import { render, staticRenderFns } from "./IconSearch.vue?vue&type=template&id=2520846e&"
import script from "./IconSearch.vue?vue&type=script&lang=js&"
export * from "./IconSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2520846e')) {
      api.createRecord('2520846e', component.options)
    } else {
      api.reload('2520846e', component.options)
    }
    module.hot.accept("./IconSearch.vue?vue&type=template&id=2520846e&", function () {
      api.rerender('2520846e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSearch.vue"
export default component.exports